import styles from './wrapup.module.css';
import PlayerAvatar from "@/components/user/avatar";
import defaultColors, { ColorId } from "@/src/types/color";
import type { WrapupUser } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";

export enum WrapupUserAvatarSize {
    Regular = 0,
    Small = 1,
}

type Props = {
    user: WrapupUser;
    size?: WrapupUserAvatarSize;
}

export default function WrapupModuleAvatar(
    {
        size = WrapupUserAvatarSize.Regular,
        user,
    }: Props,
): React.ReactNode {
    const color = defaultColors.get(user.favoriteColor ?? ColorId.Red);

    let classes = [];
    if (size === WrapupUserAvatarSize.Small) {
        classes.push(styles.avatarSmall);
    }

    return (
        <div className={styles.avatar}>
            <div className={[styles.avatarCircle, ...classes].join(' ')} style={{ backgroundColor: color.hex }}>
                <PlayerAvatar
                    src={user.avatar}
                    className={[styles.avatarImage, ...classes].join(' ')}
                />
            </div>
            <div className={[styles.avatarName, ...classes].join(' ')}>
                <h2>{user.name}</h2>
            </div>
        </div>
    );
}
